import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import NotFoundImage from 'assets/images/notFound.png';
import { Button } from 'common/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.tertiary.main,
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const MessageBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const ButtonBox = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(13),
}));

export const ExportUnavailablePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Root>
      <MessageBox>
        <img src={NotFoundImage} alt="" />
        <Typography variant="h1" sx={{ mt: 21 }}>
          {t('pages.expiredLink.expiredLinkErrorMessage')}
        </Typography>
        <ButtonBox>
          <Button variant="primary" onClick={() => navigate('/')}>
            {t('common.backToHomepage')}
          </Button>
        </ButtonBox>
      </MessageBox>
    </Root>
  );
};
